import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import ChangePasswordView from 'views/customers/configuration/changePassword/changePasswordView'; // Importing ChangePasswordView component

/**
 * Class representing the change password view.
 * @extends JetView
 */
export default class changePasswordView extends JetView {
    /**
     * Configures the layout of the change password view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Retrieves the current theme from app configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar component for the top section
                    css: theme, // Applies the current theme to the toolbar
                    elements: [
                        {
                            view: 'label', // Label component to display text
                            label: _('Cambiar Contraseña'), // Translated label text
                            width: 300, // Sets the width of the label
                        },
                    ],
                },
                ChangePasswordView, // Includes the ChangePasswordView component
            ],
        };
        webix.ui.fullScreen(); // Sets the UI to full screen mode
        return {
            height: 550, // Sets the height of the view
            type: 'wide', // Specifies the type of layout
            cols: [left], // Defines the columns layout with the left section
        };
    }
}

// FILE DOCUMENTED
